import { MenuItemType } from 'types/cms';

export const getHeaderAccountClassicItems = ({
  logout,
  notificationCount,
}: {
  logout: () => void;
  notificationCount: number | undefined;
}): MenuItemType[] => [
  {
    label: 'user.myFriends',
    href: '/profile/profile-friends/',
    acf: {
      icon: 'fa-classic fa-solid fa-users',
    },
  },
  {
    label: 'user.myTrades',
    href: '/profile/my-exchanges/',
    acf: {
      icon: 'fa-classic fa-solid fa-arrow-right-arrow-left',
    },
  },
  {
    label: 'user.adventurePass',
    href: '/profile/adventure-pass/',
    acf: {
      icon: 'fa-classic fa-solid fa-star',
    },
  },
  {
    label: 'user.notifications',
    href: '/profile/notification/',
    count: notificationCount,
    acf: {
      action: 'notification',
      icon: 'fa-classic fa-solid fa-bell',
    },
  },
  {
    label: 'user.myAccountParameters',
    href: '/manage-account/edit-information/',
    acf: {
      icon: 'fa-classic fa-solid fa-lock-keyhole',
    },
  },
  {
    label: 'user.logout',
    onClick: logout,
    acf: {
      icon: 'fa-classic fa-solid fa-door-open',
    },
  },
];

export const walletItem = {
  label: 'user.myWallet',
  href: '/manage-account/my-wallet/unlock-my-wallet/',
  acf: {
    icon: 'fa-classic fa-solid fa-coins',
  },
};

export const headerScanItem = {
  label: 'user.scanCards',
  href: '/multiscan-collection/',
  acf: {
    icon: 'fa-classic fa-solid fa-qrcode',
  },
};
// Footer image data
export const headerAccountFooterImage =
  'https://altered-cms-prod-eu.s3.eu-west-3.amazonaws.com/wp-content/uploads/sites/3/2024/01/27174018/altered_nav_account_footer.png';
